import React, { Component, ReactElement } from 'react'
import { Route } from '../Annotation/Route'
import { RouteID } from '../Components/Molecules/Header/Types/Types'
import { RouteGuard } from '../Guards/RouteGuard'
import { InsightsDashboard } from '../Components/Organisms/Insights/InsightsDashboard'

@Route(RouteID.INSIGHTS)
export class Insights extends Component {
    render(): ReactElement {
        return (
            <RouteGuard route={RouteID.INSIGHTS}>
                <InsightsDashboard />
            </RouteGuard>
        )
    }
}
